import { useEffect, useState, MouseEvent } from 'react';
import GridComponent from '../../../component/grid/GridComponent.component';
import Table from '../../../component/table/Table.component';
import { useSnackbar } from '../../../context/Snackbar';
import { Pagination } from '../../../component/table/interfaces/Pagination';
import { INITIAL_PAGINATION } from '../../../component/table/component/pagination/utils/Pagination';
import {
  Action,
  ACTION_EDIT_SUBMIT,
  ACTION_EDIT,
} from '../../../component/table/interfaces/TableInterface';
import useModal from '../../../hooks/useModal';
import Modal from '../../../component/modal/Modal.component';

import ButtonFormFullWithLoading from '../../../component/buttton/ButtonFormFullWithLoading.component';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import Form from './form/Form.component';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { compare } from '../../../utils/order/compare';
import { formatTelephone } from '../../../utils/format/FormatTelefone';
import SelectSearch, { IOption } from '../../../component/select/SelectSearch';
import { useStore } from '../../../context/Store';
import { IFlag } from '../../store/utils/Flags';
import { getRegion, putRegion } from '../../scheduleMaintenance/regions/Region.service';
import { Region } from '../../scheduleMaintenance/regions/interfaces/Region';

const ManagerRegionComponent = () => {
  const { arrayFlags } = useStore();

  const { setSnackbar } = useSnackbar();
  const [request, setRequest] = useState<boolean>(true);
  const [loadingAD, setLoadingAD] = useState<boolean>(true);
  const [canSave, setCanSave] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [region, setRegion] = useState<Region[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [selectFlag, setSelectFlag] = useState<IOption>({ label: '', value: '' });
  const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
  const [open, addModal] = useModal();
  const [openEdit, addModalEdit] = useModal();
  const [editData, setEditData] = useState<Region>();

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPagination({ ...pagination, page: newPage + 1 });
  };

  const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
    const isAsc = pagination.sort === property && pagination.order === 1;
    setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
  };

  const handleClickAction = (action: Action, region: Region) => {
    if (action === ACTION_EDIT_SUBMIT) {
      return registerRegion(region);
    }

    if (action === ACTION_EDIT) {
      setEditData(region);
      return addModalEdit(region.id);
    }
  };

  const getData = async (flag_id?: string) => {
    if (flag_id) {
      setRequest(true);
      await getRegion({ page: pagination.page, flag_id: flag_id })
        .then((response: any) => {
          if (response.data.data) {
            let data: Region[] = [];

            response.data.data.forEach((row: Region) => {
              data.push({
                ...row,
                managerAd: row.managerAd ? row.managerAd.toUpperCase() : '',
                managerPhone: row.managerPhone ? formatTelephone(row.managerPhone) : '',
              });
            });

            setRegion(data);
            setTotal(response.data.total);
          }
          setRequest(false);
        })
        .catch(() => {
          setRequest(false);
          setSnackbar({ msg: `Erro ao coletar novos dados`, type: 'error' });
        });
    } else {
      setRequest(false);
    }
  };

  useEffect(() => {
    getData(selectFlag.value);
  }, [pagination]);

  const registerRegion = async (region: Region) => {
    try {
      setSaving(true);
      region.flag_id = selectFlag.value;
      await putRegion(region);
      setSnackbar({ msg: `Regional foi atualizado com sucesso!`, type: 'success' });
      addModal(false);
      addModalEdit(false);
      setSaving(false);
      getData(selectFlag.value);
    } catch (error) {
      console.log('Erro ao submeter regional!', error);
      setSnackbar({ msg: `Erro ao atualizar regional!`, type: 'error' });
      setSaving(false);
    }
  };

  useEffect(() => {
    setLoadingAD(true);
    setCanSave(true);
    setSaving(false);
  }, [openEdit]);

  const formatArrayFlags = (): IOption[] => {
    const flagsOptions: IOption[] = [];

    arrayFlags.forEach((a: IFlag) => {
      flagsOptions.push({ label: String(a.flag), value: a.id });
    });

    return flagsOptions;
  };

  const handleChangeFlag = async (selectOption: IOption) => {
    setRegion([]);

    if (selectOption) {
      setSelectFlag(selectOption);
      await getData(selectOption.value);
    } else {
      setSelectFlag({ label: '', value: '' });
    }
  };

  return (
    <>
      <GridComponent justify='space-between' alignItems='flex-end'>
        <SelectSearch
          title='Bandeira'
          data={formatArrayFlags()}
          onChange={(event: any, selectOption: any) => handleChangeFlag(selectOption)}
          placeholder='Selecione...'
          value={selectFlag}
          request={request}
          sm={12}
          md={6}
          lg={3}
        />
      </GridComponent>

      <Modal open={!!openEdit} handleClick={() => addModalEdit(!openEdit)}>
        <Form
          initialValues={editData || INITIAL_VALUES}
          loading={loadingAD}
          handleSubmitForm={registerRegion}
          setLoading={setLoadingAD}
          setCanSave={setCanSave}
        >
          <ButtonFormFullWithLoading
            disabled={loadingAD || !canSave || saving ? true : false}
            onClick={() => addModalEdit(false)}
            loading={loadingAD}
            saving={saving}
          />
        </Form>
      </Modal>

      <br />
      <br />
      <Table
        request={request}
        data={region.sort((a: any, b: any) =>
          compare(a, b, pagination.sort || 'id', pagination.order)
        )}
        size={total}
        headCells={HEAD_CELL}
        page={pagination.page}
        onChangePage={handleChangePage}
        noActionView
        noActionDelete
        handleClickAction={handleClickAction}
        order={pagination.order === 1 ? 'asc' : 'desc'}
        orderBy={pagination.sort}
        onRequestSort={handleRequestSort}
      />
    </>
  );
};

export default ManagerRegionComponent;
